// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TripMapController from "./trip_map_controller"
application.register("trip-map", TripMapController)

import AdditionalServicesController from "./additional_services_controller"
application.register("additional-services", AdditionalServicesController)

import AnimatedRepliesController from "./animated_replies_controller"
application.register("animated-replies", AnimatedRepliesController)

import AuthFormController from "./auth_form_controller"
application.register("auth-form", AuthFormController)

import AuthModalController from "./auth_modal_controller"
application.register("auth-modal", AuthModalController)

import AuthRequiredController from "./auth_required_controller"
application.register("auth-required", AuthRequiredController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import AutoResizeController from "./auto_resize_controller"
application.register("auto-resize", AutoResizeController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AxlePeekController from "./axle_peek_controller"
application.register("axle-peek", AxlePeekController)

import StopwatchController from "./stopwatch_controller"
application.register("stopwatch", StopwatchController)

import ServiceCartController from "./service_cart_controller"
application.register("service-cart", ServiceCartController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import AvatarEditorController from "./avatar_editor_controller"
application.register("avatar-editor", AvatarEditorController)

import BookmarkController from "./bookmark_controller"
application.register("bookmark", BookmarkController)

import BrandUsernameController from "./brand_username_controller"
application.register("brand-username", BrandUsernameController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatOptionsController from "./chat_options_controller"
application.register("chat-options", ChatOptionsController)

import ChatWidgetsController from "./chat_widgets_controller"
application.register("chat-widgets", ChatWidgetsController)

import ChatHistoryController from "./chat_history_controller"
application.register("chat-history", ChatHistoryController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import InviteLinkController from "./invite_link_controller"
application.register("invite-link", InviteLinkController)

import ClockTimerController from "./clock_timer_controller"
application.register("clock-timer", ClockTimerController)

import CommentActionsController from "./comment_actions_controller"
application.register("comment-actions", CommentActionsController)

import CommentRepliesController from "./comment_replies_controller"
application.register("comment-replies", CommentRepliesController)

import CommentableController from "./commentable_controller"
application.register("commentable", CommentableController)

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import CommentsStreamController from "./comments_stream_controller"
application.register("comments-stream", CommentsStreamController)

import CoverPhotoEditorController from "./cover_photo_editor_controller"
application.register("cover-photo-editor", CoverPhotoEditorController)

import DockDropdownController from "./dock_dropdown_controller"
application.register("dock-dropdown", DockDropdownController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditModeController from "./edit_mode_controller"
application.register("edit-mode", EditModeController)

import EnhancedVideoController from "./enhanced_video_controller"
application.register("enhanced-video", EnhancedVideoController)

import EvidenceRailController from "./evidence_rail_controller"
application.register("evidence-rail", EvidenceRailController)

import FollowToggleController from "./follow_toggle_controller"
application.register("follow-toggle", FollowToggleController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageViewerController from "./image_viewer_controller"
application.register("image-viewer", ImageViewerController)

import InlineCommentsController from "./inline_comments_controller"
application.register("inline-comments", InlineCommentsController)

import LineItemsController from "./line_items_controller"
application.register("line-items", LineItemsController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InlineFormController from "./inline_form_controller"
application.register("inline-form", InlineFormController)

import InlineProfileController from "./inline_profile_controller"
application.register("inline-profile", InlineProfileController)

import InlineQuoteController from "./inline_quote_controller"
application.register("inline-quote", InlineQuoteController)

import InlineVideoController from "./inline_video_controller"
application.register("inline-video", InlineVideoController)

import KeyboardShortcutsController from "./keyboard_shortcuts_controller"
application.register("keyboard-shortcuts", KeyboardShortcutsController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import LoadingStatesController from "./loading_states_controller"
application.register("loading-states", LoadingStatesController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import MentionController from "./mention_controller"
application.register("mention", MentionController)

import NavDropdownController from "./nav_dropdown_controller"
application.register("nav-dropdown", NavDropdownController)

import NestedDropdownController from "./nested_dropdown_controller"
application.register("nested-dropdown", NestedDropdownController)

import NewPostsController from "./new_posts_controller"
application.register("new-posts", NewPostsController)

import NewPostsFloatController from "./new_posts_float_controller"
application.register("new-posts-float", NewPostsFloatController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OnboardingWizardController from "./onboarding_wizard_controller"
application.register("onboarding-wizard", OnboardingWizardController)

import OptimisticLikeController from "./optimistic_like_controller"
application.register("optimistic-like", OptimisticLikeController)

import PageControlsController from "./page_controls_controller"
application.register("page-controls", PageControlsController)

import PostComposerController from "./post_composer_controller"
application.register("post-composer", PostComposerController)

import PostDeletionController from "./post_deletion_controller"
application.register("post-deletion", PostDeletionController)

import PostViewTrackerController from "./post_view_tracker_controller"
application.register("post-view-tracker", PostViewTrackerController)

import PostingAsController from "./posting_as_controller"
application.register("posting-as", PostingAsController)

import PremiumToggleController from "./premium_toggle_controller"
application.register("premium-toggle", PremiumToggleController)

import PretripChecklistController from "./pretrip_checklist_controller"
application.register("pretrip-checklist", PretripChecklistController)

import PullToRefreshController from "./pull_to_refresh_controller"
application.register("pull-to-refresh", PullToRefreshController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import QuoteFormController from "./quote_form_controller"
application.register("quote-form", QuoteFormController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SearchSubmitController from "./search_submit_controller"
application.register("search-submit", SearchSubmitController)

import ServiceChatController from "./service_chat_controller"
application.register("service-chat", ServiceChatController)

import ServiceChecklistController from "./service_checklist_controller"
application.register("service-checklist", ServiceChecklistController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SmartFormController from "./smart_form_controller"
application.register("smart-form", SmartFormController)

import SmoothChatController from "./smooth_chat_controller"
application.register("smooth-chat", SmoothChatController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StickyCategoryController from "./sticky_category_controller"
application.register("sticky-category", StickyCategoryController)

import StickySearchController from "./sticky_search_controller"
application.register("sticky-search", StickySearchController)

import StickySidebarController from "./sticky_sidebar_controller"
application.register("sticky-sidebar", StickySidebarController)

import StopFormController from "./stop_form_controller"
application.register("stop-form", StopFormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToolbarController from "./toolbar_controller"
application.register("toolbar", ToolbarController)

import TurboInfiniteScrollController from "./turbo_infinite_scroll_controller"
application.register("turbo-infinite-scroll", TurboInfiniteScrollController)

import UniversalSearchController from "./universal_search_controller"
application.register("universal-search", UniversalSearchController)

import UserSwitchingController from "./user_switching_controller"
application.register("user-switching", UserSwitchingController)

import VideoThumbnailController from "./video_thumbnail_controller"
application.register("video-thumbnail", VideoThumbnailController)

import VinDecoderController from "./vin_decoder_controller"
application.register("vin-decoder", VinDecoderController)

import VoiceChatController from "./voice_chat_controller"
application.register("voice-chat", VoiceChatController)

import VoiceOptionsController from "./voice_options_controller"
application.register("voice-options", VoiceOptionsController)

import VotingController from "./voting_controller"
application.register("voting", VotingController)

import ProfileDropdownController from "./profile_dropdown_controller"
application.register("profile-dropdown", ProfileDropdownController)

import HeaderCollapseController from "./header_collapse_controller"
application.register("header-collapse", HeaderCollapseController)

import FullscreenSearchController from "./fullscreen_search_controller"
application.register("fullscreen-search", FullscreenSearchController)

import SheetController from "./sheet_controller"
application.register("sheet", SheetController)

import HamburgerController from "./hamburger_controller"
application.register("hamburger", HamburgerController)

import GenericSheetController from "./generic_sheet_controller"
application.register("generic-sheet", GenericSheetController)

import BookingTotalController from "./booking_total_controller"
application.register("booking-total", BookingTotalController)

import EstimateScopeController from "./estimate_scope_controller"
application.register("estimate-scope", EstimateScopeController)

import SmartDockController from "./smart_dock_controller"
application.register("smart-dock", SmartDockController)

import DockMetricsController from "./dock_metrics_controller"
application.register("dock-metrics", DockMetricsController)

import InspectionCoachController from "./inspection_coach_controller"
application.register("inspection-coach", InspectionCoachController)

import InvoicePaymentController from "./invoice_payment_controller"
application.register("invoice-payment", InvoicePaymentController)

import ScheduleController from "./schedule_controller"
application.register("schedule", ScheduleController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)

import PartPickerController from "./part_picker_controller"
application.register("part-picker", PartPickerController)

import MessengerController from "./messenger_controller"
application.register("messenger", MessengerController)

import OwnerRequestCtaController from "./owner_request_cta_controller"
application.register("owner-request-cta", OwnerRequestCtaController)

import ContactFormStartedController from "./contact_form_started_controller"
application.register("contact-form-started", ContactFormStartedController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import PlanDriveController from "./plan_drive_controller"
application.register("plan-drive", PlanDriveController)

import OrgAxleChatController from "./org_axle_chat_controller"
application.register("org-axle-chat", OrgAxleChatController)
